module.exports = __webpack_public_path__ + "04ae0db9f34377d4a6ef4734bcedc73e.png";